module.exports = {
    "global.project.center": "项目中心",
    "nav.samples": "示例",
    "nav.tutorial": "教程",
    "common.confirm": "确定",
    "common.cancel": "取消",
    "common.remove": "删除",
    "common.operation": "操作",
    "common.tip": "提示",
    "common.role": "角色",
    "common.creator": "创建者",
    "common.project": "项目",
    "common.developer": "开发者",
    "common.creation.time": "创建时间",
    "home.no.project.click": "还没有项目，请点击",
    "home.add.project": "添加项目",
    "home.add.first.project": "添加我的第一个项目",
    "home.confirm.remove.user": "确定要删除用户吗?",
    "home.project.name": "项目名称",
    "home.project.description": "项目描述",
    "home.add.user": "添加用户",
    "home.username": "用户名",
    "home.project.detail": "详细信息",
    "home.release.management": "发布管理",
    "home.development.authorization": "开发授权",
    "home.enter.workbench": "进入开发工作台",
    "home.my.role": "我的角色",
    "home.developer.list": "开发者列表",
    "home.add.member": "新增成员",
    "home.project.public": "项目公开",
    "tip.input.project.name": "请输入项目名",
    "tip.project.name.length": "项目名必须是{{min}}-{{max}}个字符",
    "tip.project.description.length": "项目描述不能超过{{max}}个字符",
    "tip.input.username": "请输入用户名",
    "tip.select.role": "请选择角色",
    "tip.no.results": "没有查询到匹配的结果",
    "delete": "删除",
    "home.confirm.remove.project": "确定要删除该项目吗？",
    "tip.exit": "确定要退出该项目吗?",
    "myProject": "我的项目",
    "deletedProject": "删除的项目",
    "cloneProject": "克隆项目",
    "grant": "授权",
    "cloneInfo": "克隆信息",
    "clonedFrom": "克隆自",
    "number": "编号",
    "removePermanent": "确定要永久删除 {{name}} 吗？",
    "startWithTest": "项目名不能用 test 开头",
    "leave": "退出项目",
    "public.project": "公开项目",
    "unpublic.project": "关闭公开",
    "home.confirm.unpublic.project": "确定要关闭公开吗?",
    "home.confirm.public.project": "项目公开后，非项目组成员可以查看工作台（不可以写入）并预览，确认要公开吗?",
    "home.sure": "知道了",
    "home.clone.tip": "关于克隆后的项目，您需进入工作台，打开每个页面查看并确认，以便重新计算价格，否则无法发布。",
    "wait.project.clone": "正在克隆项目，请稍等...",
    "pri.detail": "角色权限详情",
    "view.info": "查看项目信息",
    "del.project": "删除项目",
    "release.project": "发布项目",
    "add.project.user": "添加项目成员",
    "change.role": "修改成员角色",
    "del.member": "删除项目成员",
    "view.workbench": "查看工作台",
    "edit.workbench": "编辑工作台",
    "pri.note": "注: 对于公开的项目 任何人都可以查看该项目的工作台并能预览, 但不能编辑工作台"
}


// WEBPACK FOOTER //
// ./src/i18n/locale.zh-cn.js